































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import { IEmoji } from './types/Emoji';
import { EmojiHelper } from './helpers/emoji.helper';

@Component({
  components: {
    Picker,
  },
})
export default class EmojiPicker extends Vue {
  @Prop() customEmojis?: IEmoji[];

  get emojiIndex(): EmojiIndex {
    return EmojiHelper.emojiIndex(this.customEmojis);
  }

  skinChange(skinTone: number) {
    this.$emit('skin-change', skinTone);
  }

  hide() {
    this.$emit('hide');
  }

  select(emoji: IEmoji) {
    this.$emit('select', emoji);
  }
}
